import { Link } from 'react-router-dom';

export default function AccessDenied() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>Accès refusé</h1>
      <p>Vous n'êtes pas autorisé à accéder à cette page.</p>
      <p>
        <Link to="/">Retour à l'accueil</Link>
      </p>
    </div>
  );
}
